import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const addPostComment = async ({ commentId, postId }) => {
	try {
		return await firestore.collection('posts').doc(postId).collection('comments').doc(commentId).update({ deleted: true, modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp() })
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, commentId, postId, exception)
	}
}

export default addPostComment



// WEBPACK FOOTER //
// ./src/dataservices/deletePostComment.js